module.exports = __webpack_public_path__ + "static/img/1068.474d959.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1068.jpg
// module id = 250
// module chunks = 0